import { z, ZodBoolean } from 'zod';
import { pipe } from 'fp-ts/function';
import { array, record } from 'fp-ts';

export const flagSchema = <
    F extends { [K in keyof F]: boolean },
    K extends Extract<keyof F, string> = Extract<keyof F, string>,
>(
    flags: Array<K>
) => {
    type FlagSchemaArgs = Parameters<typeof z.object<{ [S in K]: ZodBoolean }>>[0];

    const flagSchemaArgs = flags.reduce((acc, flag) => {
        acc[flag] = z.boolean();
        return acc;
    }, {} as FlagSchemaArgs);

    return z
        .object(flagSchemaArgs)
        .partial()
        .transform((flag) =>
            pipe(
                flag,
                record.toEntries<K, boolean | undefined>,
                array.reduce({} as Required<Record<K, boolean>>, (acc, [key, value]) => {
                    acc[key] = !!value;
                    return acc;
                })
            )
        );
};
